const calculateDelay = (context, policy) => {
  const {
    attempt
  } = context;
  const {
    delay,
    factor
  } = policy;
  const retryAttempt = attempt - 1; // Do not use a delay on the first retry, or when the configured delay is 0

  if (retryAttempt === 1 || delay === 0) {
    return 0;
  } // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off

  const add = factor * delay;
  return delay + add * (retryAttempt - 2);
};
const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));
const getPolicy = configuration => {
  var _configuration$delay, _configuration$factor, _configuration$maxAtt;
  return {
    delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
    factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
    maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
  };
};
export function retry(retryable) {
  let policyConfiguration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const policy = getPolicy(policyConfiguration);
  const {
    maxAttempts
  } = policy;
  const context = {
    attempt: 1,
    attemptsRemaining: maxAttempts
  };
  const onError = async err => {
    if (context.attemptsRemaining === 0) {
      throw err;
    }
    context.attempt += 1;
    context.attemptsRemaining -= 1;
    const delay = calculateDelay(context, policy);
    if (delay) {
      await sleep(delay);
    }
    return retryable().catch(onError);
  };
  return retryable().catch(onError);
}